import PropTypes from 'prop-types'

import { idPropType } from '../../common/prop-types'

const foodMoodPropType = PropTypes.shape({
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  description: PropTypes.string,
  position: PropTypes.number.isRequired,
  imageUrl: PropTypes.string,
  dishTypes: PropTypes.arrayOf(idPropType),
  synonyms: PropTypes.arrayOf(PropTypes.string),
  isExcludedFromSearch: PropTypes.bool,
  isExcludedFromBrowsing: PropTypes.bool,
})

foodMoodPropType.defaultProps = {
  description: undefined,
  imageUrl: undefined,
  dishTypes: [],
  synonyms: [],
  isExcludedFromSearch: false,
  isExcludedFromBrowsing: false,
}

export default foodMoodPropType
